// ---------- Product card hover-cycle images ----------
document.querySelectorAll('.p-card__media[data-cycle]').forEach(media => {
  const imgs = media.querySelectorAll('img');
  const dots = media.querySelectorAll('.p-card__dots i');
  if (imgs.length < 2) return;
  let ci = 0, timer = null;
  function cycle(){
    ci = (ci + 1) % imgs.length;
    imgs.forEach((im,i)=>im.classList.toggle('active', i===ci));
    dots.forEach((d,i)=>d.classList.toggle('active', i===ci));
  }
  media.addEventListener('mouseenter', () => { timer = setInterval(cycle, 750); });
  media.addEventListener('mouseleave', () => {
    clearInterval(timer); ci = 0;
    imgs.forEach((im,i)=>im.classList.toggle('active', i===0));
    dots.forEach((d,i)=>d.classList.toggle('active', i===0));
  });
  media.addEventListener('touchstart', () => cycle(), {passive:true});
});

// ---------- Drag-to-rotate viewer (homepage + product gallery) ----------
document.querySelectorAll('[data-viewer]').forEach(stage => {
  const imgEl = stage.querySelector('img[data-viewer-img]');
  const thumbWrap = stage.parentElement.querySelector('[data-viewer-thumbs]');
  const countEl = stage.parentElement.querySelector('[data-viewer-count]');
  const prevBtn = stage.parentElement.querySelector('[data-viewer-prev]');
  const nextBtn = stage.parentElement.querySelector('[data-viewer-next]');
  let images = [];
  try { images = JSON.parse(stage.dataset.viewer || '[]'); } catch(e){ images = []; }
  if (!images.length) return;
  let idx = 0;

  if (thumbWrap && thumbWrap.dataset.mode !== 'thumb-strip') {
    thumbWrap.innerHTML = '';
    images.forEach((_, i) => {
      const b = document.createElement('button');
      if (i === 0) b.classList.add('active');
      b.addEventListener('click', () => setIdx(i));
      thumbWrap.appendChild(b);
    });
  } else if (thumbWrap) {
    [...thumbWrap.children].forEach((b, i) => b.addEventListener('click', () => setIdx(i)));
  }

  function setIdx(i){
    idx = (i + images.length) % images.length;
    imgEl.style.transition = 'opacity .18s ease';
    imgEl.style.opacity = 0;
    setTimeout(() => { imgEl.src = images[idx]; imgEl.style.opacity = 1; }, 110);
    if (countEl) countEl.textContent = String(idx + 1).padStart(2, '0');
    if (thumbWrap) [...thumbWrap.children].forEach((b, i2) => b.classList.toggle('active', i2 === idx));
  }
  setIdx(0);

  if (prevBtn) prevBtn.addEventListener('click', () => setIdx(idx - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => setIdx(idx + 1));

  let dragging = false, startX = 0, dragged = 0;
  stage.addEventListener('pointerdown', e => { dragging = true; startX = e.clientX; dragged = 0; stage.setPointerCapture(e.pointerId); });
  stage.addEventListener('pointermove', e => {
    if (!dragging) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx - dragged) > 40) { setIdx(idx + (dx > dragged ? -1 : 1)); startX = e.clientX; }
  });
  stage.addEventListener('pointerup', () => dragging = false);
  stage.addEventListener('pointerleave', () => dragging = false);
});

function formatMoney(cents){
  return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// ---------- AJAX Add to Cart (product page: avoids full-page redirect issues) ----------
function ajaxAddToCart(items, redirectTo){
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
  })
  .then(res => {
    if (!res.ok) return res.json().then(err => { throw err; });
    return res.json();
  })
  .then(() => {
    if (redirectTo) window.location.href = redirectTo + window.location.search;
  })
  .catch(err => {
    console.error('Add to cart failed', err);
    alert((err && err.description) || 'Could not add to cart. Please check the product has available stock.');
  });
}

const productForm = document.getElementById('product-form');
if (productForm) {
  const qtyInput = document.getElementById('mainQty');
  function buildItems(){
    const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    const items = [];
    const variantId = productForm.dataset.variant;
    if (variantId) items.push({ id: parseInt(variantId, 10), quantity: qty });
    return items;
  }
  productForm.addEventListener('submit', e => {
    e.preventDefault();
    const btn = document.getElementById('addToCartBtn');
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding...'; }
    ajaxAddToCart(buildItems(), '/cart').finally(() => {
      if (btn) { btn.disabled = false; }
    });
  });
}

// ---------- Sticky bar quantity kept in sync with main quantity ----------
const stickyQtyInput = document.getElementById('stickyQty');
const mainQtyInput = document.getElementById('mainQty');
if (stickyQtyInput && mainQtyInput) {
  stickyQtyInput.addEventListener('change', () => { mainQtyInput.value = stickyQtyInput.value; });
  mainQtyInput.addEventListener('change', () => { stickyQtyInput.value = mainQtyInput.value; });
}

// ---------- Sticky bar Add to Cart ----------
const stickyAddToCartBtn = document.getElementById('stickyAddToCartBtn');
if (stickyAddToCartBtn) {
  stickyAddToCartBtn.addEventListener('click', () => {
    const qty = parseInt(stickyQtyInput ? stickyQtyInput.value : '1', 10) || 1;
    const variantId = productForm ? productForm.dataset.variant : null;
    if (!variantId) return;
    stickyAddToCartBtn.disabled = true;
    stickyAddToCartBtn.dataset.originalText = stickyAddToCartBtn.textContent;
    stickyAddToCartBtn.textContent = 'Adding...';
    ajaxAddToCart([{ id: parseInt(variantId, 10), quantity: qty }], '/cart')
      .finally(() => {
        stickyAddToCartBtn.disabled = false;
        stickyAddToCartBtn.textContent = stickyAddToCartBtn.dataset.originalText;
      });
  });
}

// ---------- Quick-add to cart from product cards (collection/search/homepage grids) ----------
document.querySelectorAll('[data-quick-add]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variant;
    if (!variantId) return;
    btn.disabled = true;
    ajaxAddToCart([{ id: parseInt(variantId, 10), quantity: 1 }], null)
      .then(() => {
        btn.classList.add('added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg><span>Added</span>';
        const badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = (parseInt(badge.textContent, 10) || 0) + 1;
        else {
          const cartLink = document.querySelector('.nav__icons a[href*="cart"]');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = '1';
            cartLink.appendChild(span);
          }
        }
        setTimeout(() => {
          btn.classList.remove('added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2"><path d="M6 2l1.5 4h9L18 2"/><path d="M3.5 6h17l-1.6 12.5a2 2 0 0 1-2 1.5H7.1a2 2 0 0 1-2-1.5L3.5 6z"/><path d="M9 10v4M12 10v4"/></svg><span>Add</span>';
        }, 1800);
      })
      .finally(() => { btn.disabled = false; });
  });
});

// ---------- Multi-product featured viewer tabs ----------
document.querySelectorAll('[data-fp-tab]').forEach(tab => {
  tab.addEventListener('click', () => {
    const idx = tab.dataset.fpTab;
    document.querySelectorAll('[data-fp-tab]').forEach(t => {
      t.classList.toggle('btn--fill', t === tab);
      t.classList.toggle('btn--line', t !== tab);
    });
    document.querySelectorAll('[data-fp-panel]').forEach(p => {
      p.style.display = p.dataset.fpPanel === idx ? '' : 'none';
    });
  });
});
document.querySelectorAll('[data-fp-add]').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.disabled = true;
    ajaxAddToCart([{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }], '/cart')
      .finally(() => { btn.disabled = false; });
  });
});

// ---------- Mobile nav drawer ----------
const mobileNavToggle = document.getElementById('mobileNavToggle');
const mobileNav = document.getElementById('mobileNav');
const mobileNavClose = document.getElementById('mobileNavClose');
const mobileNavBackdrop = document.getElementById('mobileNavBackdrop');
function toggleMobileNav(open){
  if (mobileNav) mobileNav.classList.toggle('open', open);
  if (mobileNavBackdrop) mobileNavBackdrop.classList.toggle('open', open);
}
if (mobileNavToggle) mobileNavToggle.addEventListener('click', () => toggleMobileNav(true));
if (mobileNavClose) mobileNavClose.addEventListener('click', () => toggleMobileNav(false));
if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', () => toggleMobileNav(false));

// ---------- FAQ accordion ----------
document.querySelectorAll('.faq-item button').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

// ---------- Sticky add-to-cart bar: always visible on the product page (class "show" is set in the markup) ----------

// ---------- Quantity steppers (product page + cart) ----------
document.querySelectorAll('[data-qty-wrap]').forEach(wrap => {
  const input = wrap.querySelector('input');
  const minus = wrap.querySelector('[data-qty-minus]');
  const plus = wrap.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', () => {
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  if (plus) plus.addEventListener('click', () => {
    input.value = parseInt(input.value || '1', 10) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

// ---------- Cart page: live update via Shopify AJAX Cart API ----------
document.querySelectorAll('[data-cart-qty-input]').forEach(input => {
  let debounceTimer;
  input.addEventListener('change', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => updateCartLine(input.dataset.line, input.value), 350);
  });
});
document.querySelectorAll('[data-cart-remove]').forEach(btn => {
  btn.addEventListener('click', () => updateCartLine(btn.dataset.line, 0));
});
function updateCartLine(line, quantity){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
  })
  .then(res => res.json())
  .then(() => window.location.reload())
  .catch(err => console.error('Cart update failed', err));
}

// ---------- Free shipping progress bar (cart page) ----------
const shipFill = document.getElementById('shipFill');
const shipText = document.getElementById('shipText');
if (shipFill && shipText) {
  const subtotal = parseInt(shipFill.dataset.subtotal || '0', 10);
  const limit = parseInt(shipFill.dataset.limit || '1599', 10);
  const pct = Math.min(100, (subtotal / limit) * 100);
  shipFill.style.width = pct + '%';
  shipText.innerHTML = subtotal >= limit
    ? '🎉 <b>You\'ve unlocked FREE shipping!</b>'
    : `Add <b>₹${limit - subtotal}</b> more to unlock FREE shipping`;
}

// ---------- Search page: live filter on the results already rendered ----------
const searchInput = document.getElementById('liveSearchInput');
if (searchInput) {
  const cards = document.querySelectorAll('[data-search-card]');
  const resultCount = document.getElementById('resultCount');
  const noResults = document.getElementById('noResults');
  searchInput.addEventListener('input', () => {
    const q = searchInput.value.toLowerCase().trim();
    let visible = 0;
    cards.forEach(card => {
      const match = !q || (card.dataset.searchTerms || '').toLowerCase().includes(q);
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    if (resultCount) resultCount.textContent = visible;
    if (noResults) noResults.style.display = visible ? 'none' : 'block';
  });
  document.querySelectorAll('.search-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      searchInput.value = tag.dataset.tag;
      searchInput.dispatchEvent(new Event('input'));
    });
  });
}

// ---------- Contact form (Shopify handles submission; this just shows a note if JS-only preview) ----------
const contactForm = document.getElementById('contactForm');
if (contactForm) {
  contactForm.addEventListener('submit', () => {
    // Shopify's native contact form action handles the POST; nothing else needed here.
  });
}

// ---------- Hero slider ----------
document.querySelectorAll('.hero-slider').forEach(slider => {
  const track = slider.querySelector('.hero-slider__track');
  const slides = slider.querySelectorAll('.hero-slide');
  const dots = slider.querySelectorAll('[data-hero-dot]');
  const prevBtn = slider.querySelector('[data-hero-prev]');
  const nextBtn = slider.querySelector('[data-hero-next]');
  if (!track || slides.length <= 1) return;
  let idx = 0;
  let timer = null;
  function goTo(i){
    idx = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${idx * 100}%)`;
    dots.forEach((d, di) => d.classList.toggle('active', di === idx));
  }
  function restartAutoplay(){
    if (timer) clearInterval(timer);
    if (slider.dataset.autoplay === 'true') {
      const speed = (parseInt(slider.dataset.speed, 10) || 6) * 1000;
      timer = setInterval(() => goTo(idx + 1), speed);
    }
  }
  if (prevBtn) prevBtn.addEventListener('click', () => { goTo(idx - 1); restartAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { goTo(idx + 1); restartAutoplay(); });
  dots.forEach((d, di) => d.addEventListener('click', () => { goTo(di); restartAutoplay(); }));

  let touchStartX = 0;
  track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) { goTo(idx + (dx < 0 ? 1 : -1)); restartAutoplay(); }
  }, { passive: true });

  restartAutoplay();
});
